module.exports = __webpack_public_path__ + "static/media/flag.c9a93034.svg";